const CONSTANT = {
  NO_DATA_FOUND: 'No data found!',
  MANAGE_COUNTRY: 'Manage Countries',
  ADD_NEW_COUNTRY: 'Add New Country',
  ADD_NEW_COUNTRY_AND_ADOPTION: 'Add New Country / Adoption',
  MANAGE_STATE: 'Manage States',
  MANAGE_JURISDICTION: 'Manage Jurisdictions',
  MANAGE_TOWNSHIP: 'Manage Townships',
  ADD_NEW_JURISDICTION: 'Add New Jurisdiction',
  ADD_JURISDICTION: 'Add Jurisdiction',
  EDIT_JURISDICTION: 'Edit Jurisdiction',
  ADD_NEW_TOWNSHIP: 'Add New Township',
  ADD_NEW_STATE: 'Add New State',
  MANAGE_COUNTY: 'Manage Counties',
  ADD_NEW_COUNTY: 'Add New County',
  APPLICATION_TITLE: 'Adoption Information Solution',
  WELCOME: 'Welcome',
  SOMETHING_WENT_WRONG: 'Something went wrong! Please try again after sometime.',
  VALID_USERNAME_AND_PASSWORD_ERROR_MESSAGE: 'Please enter E-mail and Password!',
  LOGOUT: 'Logout',
  NO_COUNTY_IS_AVAILABLE_FOR_THE_SELECTED_STATE: 'No County is available for the selected State.',
  NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY: 'No State is available for the selected Country.',
  NO_JURISDICTION_IS_AVAILABLE_FOR_THE_SELECTED_STATE_OR_COUNTY: 'No Jurisdiction is available for the selected State or County.',
  NO_TOWNSHIP_IS_AVAILABLE_STATE_OR_COUNTY: 'No Township is available for the selected State or County.',
  MANAGE_PUBLISHER: 'Manage Publishers',
  ADD_NEW_PUBLISHER: 'Add New Publisher',
  EDIT_PUBLISHER: 'Edit Publisher',
  ADD_PUBLISHER: 'Add Publisher',
  MANAGE_CODE_YEAR: 'Manage Code Year',
  ADD_NEW_CODE_YEAR: 'Add New Code Year',
  MANAGE_ADOPTION_PROFILE: 'Manage Adoption Profile',
  ADD_NEW_ADOPTION_PROFILE: 'Add New Adoption Profile',
  RECORDS_STATUS: ['Inactive', 'Published'],
  DEFAULT_RECORDS_STATUS: 'Inactive',
  DEFAULT_RECORDS_STATUS_VALUE: { 'Inactive': 1, 'Published': 2 },
  MANAGE_ADOPTION_STATUS: 'Manage Adoption Status',
  MANAGE_ADOPTION_TYPE: 'Manage Adoption Type',
  MANAGE_CODE_BOOK: 'Manage Code Books',
  ADD_NEW_CODE_BOOK: 'Add New Code Book',
  EDIT_CODE_BOOK: 'Edit Code Book',
  ADD_CODE_BOOK: 'Add Code Book',
  MANAGE_ADOPTION_LABEL: 'Manage Adoption Label',
  ADD_ADOPTION_LABEL: 'Add Adoption Label',
  EDIT_ADOPTION_LABEL: 'Edit Adoption Label',
  MANAGE_ADOPTION: 'Manage Adoption',
  ADD_ADOPTION: 'Add Adoption',
  EDIT_ADOPTION: 'Edit Adoption',
  ADD_NEW_ADOPTION_FORM_TITLE: 'Add New Adoption',
  EDIT_ADOPTION_FORM_TITLE: 'Edit Adoption',
  INCATIVE_USER_ERROR_MSG: 'Your account is inactive',
  ACTIVE_USER_DEFAULT_STATUS: 2,
  ADOPTION_STATUS: ['State', 'County', 'Jurisdiction', 'Township'],
  DEFAULT_ADOPTION_STATUS_VALUE: { 'State': 1, 'County': 2, 'Jurisdiction': 3, 'Township': 4 },
  ADOPTION_STATUS_FIELD: ['Current Adoption', 'Past Adoption'],
  DEFAULT_ADOPTION_STATUS_FIELD_VALUE: { 'Current_Adoption': 1, 'Past_Adoption': 2 },
  DEFAULT_ADOPTION_STATUS_FIELD: 'Current Adoption',
  ADOPTION_TYPE_FIELD: ['Approved', 'Denied', 'Proposed'],
  DEFAULT_ADOPTION_TYPE_FIELD_VALUE: { 'Proposed': 1, 'Approved': 2, 'Denied': 3 },
  DEFAULT_ADOPTION_TYPE_FIELD: 'Approved',
  MANAGE_POSTAL_CODE: 'Manage Postal Code',
  ADD_NEW_POSTAL_CODE: 'Add New Postal Code',
  EDIT_POSTAL_CODE: 'Edit Postal Code',
  VALID_USERNAME_ERROR_MESSAGE: 'Please enter E-mail',
  VIEW_AUDIT_LOGS: 'View Audit Logs',
  RESET_PASSWORD_BASE_LINK: 'http://adoptionfrontend-dev.iccsafe.org/admin/resetpassword',
  TOOLTIPTEXT1: 'Adoptions(s) added from here will have below default values:',
  TOOLTIPTEXT2: 'Effective Date: Null (User may add it from Adoption screen later)',
  TOOLTIPTEXT3: 'Adoption Label: Null (User may add it from Adoption screen later)',
  TOOLTIPTEXT4: 'Adoption Status: Current',
  TOOLTIPTEXT5: 'Adoption Type: Approved',
  SEARCH_ADOPTION: 'Search Adoption:',
  ADD_BULK_ADOPTION: 'Manage Adoption for',
  SEARCH_JURISDICTION: 'Search Jurisdiction:',
  SEARCH_TOWNSHIP: 'Search Township:',
  EXPORT_CSV_LIMIT: 50000,
  STATE_LEVEL: 1,
  COUNTY_LEVEL: 2,
  JURISDICTION_LEVEL: 3,
  TOWNSHIP_LEVEL: 4,
  ABBR_PARENT_LEVEL: 0,
  MAP_STATE_NOT_FOUND: 'State not found',
  MAP_COUNTY_NOT_FOUND: 'County not found',
  MAP_JURISDICTION_NOT_FOUND: 'Jurisdiction not found',
  LOCATION_NOT_FOUND: 'Location not present in the system. Please use the search box to find the nearby location.',
  BULK_ADOPTION_URL: { '1': 'states', '2': 'counties', '3': 'jurisdictions', '4': 'townships' },
  LOCATION_ENTITY_LIST: [
    { name: 'Country', id: 1 },
    { name: 'State', id: 2 },
    { name: 'County', id: 3 },
    { name: 'Jurisdiction', id: 4 },
    { name: 'Postal Code', id: 5 },
    { name: 'Township', id: 6 },
    { name: 'Useful Links', id: 7 }
  ],
  COUNTRY_ENTITY_TEXT: 'Upload country location data. CSV format must include columns for each mandatory field including Country Name. Optional fields include Abbreviation and UN Code.',
  STATE_ENTITY_TEXT: 'Upload state location data. CSV format must include columns for each mandatory field including State Name, Abbreviation and Country. Optional fields include FIPs, Adoption Profile, Amendments Made, Amendments and Code Office URL.',
  COUNTY_ENTITY_TEXT: 'Upload county location data. CSV format must include columns for each mandatory field including County Name, Country and State. Optional fields include FIPs, Adoption Profile, Amendments Made, Amendments and Code Office URL.',
  JURISDICTION_ENTITY_TEXT: 'Upload jurisdiction location data. CSV format must include columns for each mandatory field including Jurisdiction Name, Country and State. Optional fields include Formerly Known As, County, FIPs, Adoption Profile, Amendments Made, Amendments, Postal Code and Code Office URL.',
  POSTALCODE__ENTITY_TEXT: 'Upload postal code data. CSV format must include columns for Postal Code.',
  TOWNSHIP_ENTITY_TEXT: 'Upload township location data. CSV format must include columns for each mandatory field including Township Name, Country, State and County. Optional fields include Formerly Known As, FIPs, Adoption Profile, Amendments Made, Amendments and Code Office URL.',
  USEFULLINKS_ENTITY_TEXT: 'Upload useful links data for locations. CSV format must include columns for each mandatory field including Location Name, Type, County, State, Link and Display Text',
  CODEBOOK_UPLOAD_OPTIONS: [
    { 'key': 'book', name: 'Code Book' },
    { 'key': 'year', name: 'Code Year' },
    { 'key': 'publisher', name: 'Publisher' }
  ],
  BOOK_UPLOAD_HELP_TEXT: 'Upload code book data. CSV format must include columns for each mandatory field including Book Title,  Abbreviation, Code Year and Publisher. Optional fields include SKU, Content URL and Product URL.',
  YEAR_UPLOAD_HELP_TEXT: 'Upload code year data. CSV format must include column for Code Year.',
  PUBLISHER_UPLOAD_HELP_TEXT: 'Upload publisher data. CSV format must include columns for each mandatory field including Publisher Name and Acronym.',
  MANAGE_PROPOSED_ADOPTIONS: 'Proposed Code Adoptions',
  DEFAULT_COUNTRY_NAME: 'USA',
  DEFAULT_COUNTRY_ABBR: 'US',
  DEFAULT_US_LAT: 37.0902,
  DEFAULT_US_LNG: -95.7129,
  DISCLAIMER_TEXT: 'Adoption information across this site is maintained through a collaborative effort between the International Code Council, Federal Alliance for Safe Homes (FLASH) and ISO. The Code Council, FLASH and ISO make every effort to provide current, accurate code adoption information. Not all jurisdictions notify the Code Council, FLASH or ISO of code adoptions. To obtain more detailed information on amendments and changes to adopt codes, please contact the jurisdiction. To submit adoption information, please visit our <a href="https://www.iccsafe.org/advocacy/code-adoptions-submit/" target="_blank" style="cursor:pointer;">Submit Code Adoptions</a> page.',
  DISCLAIMER_TEXT_ICODE: 'Adoption information across this display is maintained by the International Code Council (ICC). ICC makes every effort to provide current, accurate code adoption information. To obtain more detailed information on amendments and changes to adopt codes, please contact the jurisdiction. To submit adoption information, please visit our <a href="https://www.iccsafe.org/advocacy/code-adoptions-submit/" target="_blank" style="cursor:pointer;">Code Adoptions Resources</a> page.',
  NO_ADOPTION_TEXT: '<p class="mt-2 mb-2" >To submit adoption information for this location, please visit our <a href="https://www.iccsafe.org/advocacy/code-adoptions-submit/" target="_blank" style="cursor:pointer;">Code Adoptions Resources</a> page.</p> For information on the benefits of adoption, sample adoption ordinances, and other adoption resources, please see our <a href="https://www.iccsafe.org/code-adoption-resources/" target="_blank" style="cursor:pointer;">Code Adoption Toolkit</a>.<br/> For information on how building codes support safe, sustainable, and resilient communities, please see our <a href="https://www.iccsafe.org/codessave/" target="_blank" style="cursor:pointer;">Codes Save page</a>.',
  NO_DATA_FOUND_PART_II: ' however not all jurisdictions notify ICC or ISO of code adoptions.<br/>To obtain more detailed information on amendments and changes to adopted codes, please contact this jurisdiction directly.',
  MANAGE_ADOPTION_ACTIVITY: 'Adoption Activity',
  ADD_TOWNSHIP: 'Add Township',
  SEARCH_FILTERS: ['All Locations', 'Country', 'State', 'County', 'Jurisdiction', 'Township'],
  SEARCH_FILTERS_DEFAULT: 'All Locations',
  SAMPLE_DOWNLOAD: {
    ILD_PAGE: {
      COUNTRY_DOWNLOAD_FILE: 'country_template.csv',
      STATE_DOWNLOAD_FILE: 'state_template.csv',
      COUNTY_DOWNLOAD_FILE: 'county_template.csv',
      JURISDICTION_DOWNLOAD_FILE: 'jurisdiction_template.csv',
      TOWNSHIP_DOWNLOAD_FILE: 'township_template.csv',
      USEFULLINKS_DOWNLOAD_FILE: 'usefullink_template.csv',
      POSTALCODE_DOWNLOAD_FILE: 'postal_code_template.csv',
      COUNTRY_DOWNLOAD_TEXT: 'Country',
      STATE_DOWNLOAD_TEXT: 'State',
      COUNTY_DOWNLOAD_TEXT: 'County',
      JURISDICTION_DOWNLOAD_TEXT: 'Jurisdiction',
      TOWNSHIP_DOWNLOAD_TEXT: 'Township',
      POSTALCODE_DOWNLOAD_TEXT: 'Postal Code',
      USEFULLINKS_DOWNLOAD_TEXT: 'Useful Links'
    },
    ICB_PAGE: {
      CODE_BOOK_DOWNLOAD_FILE: 'code_book_template.csv',
      CODE_YEAR_DOWNLOAD_FILE: 'code_year_template.csv',
      PULISHER_DOWNLOAD_FILE: 'publisher_template.csv',
      CODE_BOOK_DOWNLOAD_TEXT: 'Code Book',
      CODE_YEAR_DOWNLOAD_TEXT: 'Code Year',
      PULISHER_DOWNLOAD_TEXT: 'Publisher'
    },
    IAD_PAGE: {
      CODE_ADOPTION_DOWNLOAD_FILE: 'code_adoption_template.csv',
      CODE_ADOPTION_DOWNLOAD_TEXT: 'Code Adoption'
    },
    IADI_PAGE: {
      CODE_ADOPTION_DOWNLOAD_FILE: 'code_adoption_information_template.csv',
      CODE_ADOPTION_DOWNLOAD_TEXT: 'ICC Code Adoption'
    }
  },
  ADD_NEW_ICODE_COLOR: 'Add New I-Code Color',
  MANAGE_ICODE_COLOR: 'Manage I-Code Color',
  EDIT_ICODE_COLOR: 'Edit I-Code Color',
  LOCAL_ADOPTION_LISTING_PAGE: 'Local Adoption Listing for I-Code Map',
  I_CODES_FOR_LOCAL_ADOPTION: [
    { 'code': 'IBC', title: 'International Building Code' },
    { 'code': 'ICCPC', title: 'ICC Performance Code for Buildings and Facilities' },
    { 'code': 'IEBC', title: 'International Existing Building Code' },
    { 'code': 'IECC', title: 'International Energy Conservation Code' },
    { 'code': 'IFC', title: 'International Fire Code' },
    { 'code': 'IFGC', title: 'International Fuel Gas Code' },
    { 'code': 'IgCC', title: 'International Green Construction Code' },
    { 'code': 'IMC', title: 'International Mechanical Code' },
    { 'code': 'IPC', title: 'International Plumbing Code' },
    { 'code': 'IPMC', title: 'International Property Maintenance Code' },
    { 'code': 'IPSDC', title: 'International Private Sewage Disposal Code' },
    { 'code': 'IRC', title: 'International Residential Code' },
    { 'code': 'ISPSC', title: 'International Swimming Pool and Spa Code' },
    { 'code': 'IWUIC', title: 'International Wildland-Urban Interface Code' },
    { 'code': 'IZC', title: 'International Zoning Code' }
  ],
  MAP_STATIC_COLOR: {
    DEFAULT_COLOR_CODE: '#999999',
    DEFAULT_MIXED_COLOR_CODE: '#0b583f',
    DEFAULT_LOCAL_COLOR_CODE: '#90EE90'
  },
  IMPORTED_INFO: 'Imported Information',
  SEARCH_IMPORTS: 'Search Imports:',
  SEARCH_STATE: 'Search State:',
  SEARCH_COUNTY: 'Search County:',
  ROLE_ADMIN: 'ROLE_ADMIN',
  NOAUTH_USER_ERROR_MSG: 'Forbidden: You don’t have permission to access application.',
  DISCLAIMER_TEXT_ROLE_API_USER: 'Disclaimer: This user will have read only api access and cannot login to the application.',
  SEARCH_CODE_BOOK: 'Search Code Book'
}

export default CONSTANT
